const getActionName = (actionType) => {
    if (typeof actionType !== 'string') {
        return null;
    }
    const lastItem = actionType.split('_')[actionType.split('_').length - 1];

    return actionType
        .split('_')
        .filter((item) => item !== lastItem)
        .join('_');
};
export default getActionName;
